import { createAxios } from "./client.js";
const client = createAxios();

export default {
  get() {
    return client.get("get");
  }
};
